<i18n>
{
	"en": {
		"cancelLabel": "Cancel",
		"title": "Search for Clerk",
		"chooseClerk": "Choose Clerk",
		"searchPlaceholder": "Search text",
		"name": "Name",
		"email": "Mail"
	},
	"no": {
		"cancelLabel": "Avbryt",
		"title": "Søk etter ansvarlig",
		"chooseClerk": "Velg ansvarlig",
		"searchPlaceholder": "Søketekst",
		"name": "Navn",
		"email": "Mail"
	}
}
</i18n>

<template>
	<t-dialog
		:icon="icon"
		:isShown="isShown"
		:title="$t('title')"
		:confirmLabel="$t('chooseClerk')"
		:cancelLabel="$t('cancelLabel')"
		:isConfirmDisabled="selectedClerk === undefined"
		focusFirstOnShow
		iconType="bp"
		@close="onClose"
		@ok="onOk"
		@shown="onShown"
	>
		<t-form-group>
			<t-search-input v-model="searchValue" :placeholder="$t('searchPlaceholder')"/>
			<t-grid
				v-if="showGrid"
				:items="filteredItems"
				:columnDefinitions="columnDefinitions"
				:defaultColumnDefinition="defaultColumnDefinition"
				:rowHeight="40"
				:showFilters="false"
				:singleSelect="true"
				:selectableMode="['row']"
				selectable
				style="height: 400px; width: 500px;"
				@selected="setSelectedClerk"
				@enter="onEnter"
				@rowDoubleClick="selectAndClose"
			/>
		</t-form-group>
	</t-dialog>
</template>

<script>
export default {
	name: 'ClerksDialog',
	props: {
		icon: String,
		isShown: Boolean,
		title: String,
		items: Array,
		initialSearchValue: String
	},
	data() {
		return {
			searchValue: '',
			showGrid: false,
			selectedClerk: undefined,
			defaultColumnDefinition: { resizable: false, }
		};
	},
	computed: {
		filteredItems() {
			if (!this.searchValue || this.searchValue === '') return this.items;
			return this.items.filter(item => this.filterItem(item, this.searchValue));
		},
		columnDefinitions() {
			return [
				{
					field: 'name',
					displayName: this.$t('name'),
					minWidth: 150,
					resizable: true,
				},
				{
					field: 'email',
					displayName: this.$t('email'),
					width: 150,
				}
			];
		}
	},
	methods: {
		onShown() {
			if (this.initialSearchValue) {
				this.searchValue = this.initialSearchValue;
			}
			this.showGrid = true;
		},
		filterItem(item, searchString) {
			if (!item) return false;
			let ret = true;
			for (let c of searchString.split(' ')) {
				ret = ret &&
					( (item.name && item.name.toLowerCase().includes(c.toLowerCase()))
					|| ( item.email && item.email.toString().toLowerCase().includes(c.toLowerCase()) )
					);
			}
			return ret;
		},
		selectAndClose(clerkId) {
			if (!clerkId) return;
			this.selectedClerk = this.items.find( (x) => x.id === clerkId);
			this.onOk();
			this.onClose();
		},
		onEnter() {
			if (!this.selectedClerk) return;
			this.onOk();
			this.onClose();
		},
		setSelectedClerk(clerkId) {
			if (!clerkId) return;
			let clerk = this.items.find(x => x.id === clerkId[0]);
			this.selectedClerk = clerk;
		},
		onClose() {
			this.$emit('close');
			this.selectedClerk = undefined;
			this.searchValue = '';
			this.showGrid = false;
		},
		onOk() {
			this.$emit('ok', this.selectedClerk);
			this.selectedClerk = undefined;
			this.searchValue = '';
			this.showGrid = false;
		}
	}
};
</script>

